import { render, staticRenderFns } from "./WkUserCheckbox.vue?vue&type=template&id=204351ee&scoped=true"
import script from "./WkUserCheckbox.vue?vue&type=script&lang=js"
export * from "./WkUserCheckbox.vue?vue&type=script&lang=js"
import style0 from "./WkUserCheckbox.vue?vue&type=style&index=0&id=204351ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204351ee",
  null
  
)

export default component.exports